import { Model } from './Model'
import { IdType, InvoiceItemDataType } from '@/types'

export class InvoiceItem extends Model {
    raw: InvoiceItemDataType

    warranty_product_name: string

    policy_number?: string

    warranty_id?: IdType

    panel_count?: number

    system_size?: number

    contact_name?: string

    address?: string

    total_price: number

    constructor(data: InvoiceItemDataType) {
        super(data)
        this.raw = data
        this.warranty_product_name = data.warranty_product_name
        this.policy_number = data.policy_number
        this.warranty_id = data.warranty_id
        this.panel_count = data.panel_count
        this.system_size = data.system_size
        this.contact_name = data.contact_name
        this.address = data.address
        this.total_price = data.total_price
    }
}
